import React, { Component } from "react";
import { getItems, deleteItem } from "../../services/itemService";
import Pagination from "../common/pagination";
import { paginate } from "../../utils/paginate";
import SupplierItemsTable from "./supplierItemsTable";
import Confirmation from "../common/confirmation";

import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import _ from "lodash";
import BlockUi from "react-block-ui";
import { Button } from "semantic-ui-react";
import Input from "../common/input";
import Select from "../common/select";

import {
  getCategories,
  getDropDownCategories,
} from "../../services/categoryService";
// import Form from "../common/form";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import NotFound from "../common/notfound";

class SupplierItems extends Component {
  state = {
    startDate: new Date(),
    items: [],
    item: "",

    open: false,
    pageSize: 50,
    currentPage: 1,

    sortColumn: { path: "title", order: "asc" },
    noRecordFound: "",
    categories: [],

    keyFieldValue: "",
    category_id: "",
    orderPanel: "none",
    searching: false,
  };

  async componentDidMount() {
    const { data: cats } = await getDropDownCategories();
    const categories = [{ id: "", name: "All Categories" }, ...cats];

    this.setState({ blocking: true });
    const { data: items } = await getItems();
    this.state.blocking = false;
    this.setState({
      items,
      blocking: false,
      categories,
    });
  }

  handleDelete = (item) => {
    this.setState({ open: true, item });
  };

  handleCancel = () => {
    this.setState({ open: false });
  };

  doDelete = async () => {
    const item = this.state.item;
    const originalItems = this.state.items;
    const items = originalItems.filter((o) => o.id !== item.id);
    this.setState({ items });

    try {
      await deleteItem(item.id);
      toast.success("Item has been updated successfully.");
    } catch (ex) {
      if (ex.response && ex.response.status === 404) {
        toast.success("This item has already been deleted.");
      }

      this.setState({ items: originalItems });
    }
  };

  handleUpdate = (item) => {
    return this.props.history.replace("/items/" + item.id + "/edit");
  };

  handlePageChange = (page) => {
    this.setState({ currentPage: page });
  };

  handleSearching = (keyword, category_id) => {
    this.setState({
      keyFieldValue: keyword,
      category_id,
      currentPage: 1,
      searching: true,
    });
  };

  handleSort = (sortColumn) => {
    this.setState({ sortColumn });
  };

  getPagedData = () => {
    const {
      pageSize,
      currentPage,
      items: allItems,
      sortColumn,
      keyFieldValue,
      category_id,
    } = this.state;

    let filtered = allItems;

    filtered = keyFieldValue
      ? allItems.filter(
          (m) => m.name.toUpperCase().indexOf(keyFieldValue.toUpperCase()) > -1
        )
      : filtered;

    filtered = category_id
      ? filtered.filter((m) => m.category.id == category_id)
      : filtered;

    const sorted = _.orderBy(filtered, [sortColumn.path], [sortColumn.order]);

    const items = paginate(sorted, currentPage, pageSize);
    return { totalCount: filtered.length, data: items };
  };

  clearFilters() {
    document.getElementById("keyword").value = "";
    document.getElementById("category_id").value = "";
    this.setState({
      data: { category_id: "" },
    });
    document.getElementById("searcBtn").click();
  }

  cardVisibility() {
    if (this.state.orderPanel === "none") return "none";
    return "block";
  }

  handleChange = (date) => {
    this.setState({
      startDate: date,
    });
  };

  render() {
    const { pageSize, currentPage, sortColumn, searching } = this.state;
    const { totalCount, data: items } = this.getPagedData();
    const { count } = items.length;

    if (
      (items.length === 0 || items.length === undefined) &&
      this.state.blocking === false &&
      searching === false
    ) {
      return (
        <NotFound
          title="Supplies"
          linkTitle="Supply"
          link="/items/new"
          button={true}
        />
      );
    }

    return (
      <BlockUi tag="div" blocking={this.state.blocking}>
        <Confirmation
          open={this.state.open}
          module="item"
          onDelete={this.doDelete}
          onCancel={this.handleCancel}
        />

        <h1 className="container__heading">Items</h1>

        <article className="grid filters filters--items">
          <Input
            id="keyword"
            name="keyword"
            style={{ width: "100%" }}
            placeholder="Search by keyword"
          />
          <Select
            name="category_id"
            id="category_id"
            options={this.state.categories}
          />

          <button
            onClick={() =>
              this.handleSearching(
                document.getElementById("keyword").value,
                document.getElementById("category_id").value
              )
            }
            id="searcBtn"
            className="btn btn--primary"
            type="button"
          >
            Search
          </button>

          <button
            onClick={() => this.clearFilters()}
            className="btn btn--secondary"
            type="button"
          >
            Reset
          </button>

          <Link
            to="/items/new"
            className="btn btn--accent"
            style={{ margin: 0 }}
          >
            + Item
          </Link>
        </article>

        <p className="container__count">Showing {totalCount} items.</p>

        <div className="supplier-items">
          <SupplierItemsTable
            items={items}
            sortColumn={sortColumn}
            onDelete={this.handleDelete}
            onUpdate={this.handleUpdate}
            onSort={this.handleSort}
            onIncrement={this.handleIncrement}
            onDecrement={this.handleDecrement}
          />
        </div>

        <Pagination
          itemsCount={totalCount}
          pageSize={pageSize}
          onPageChange={this.handlePageChange}
          currentPage={currentPage}
        />
      </BlockUi>
    );
  }
}

export default SupplierItems;
